<template>
    <div style="width: 100%">
        <div
            @click="toggleBody"
            @mouseenter="toggleBody"
            @mouseleave="closeByHover"
            :id="`selector-${id}`"
            ref="selector"
        >
            <slot name="selector"></slot>
        </div>
        <div
            @click="bodyOpened = false"
            :class="{ '-no-events': type == 'hover' }"
            class="filter-click-area"
            v-if="bodyOpened"
        ></div>
        <transition name="fade">
            <div
                v-if="bodyOpened"
                ref="body"
                class="overlay-body"
                :style="{ marginTop: offsetY }"
                id="body"
            >
                <slot name="body"></slot>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        timeout: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: 'click'
        },
        id: {
            type: String,
            default: 'default'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        position: {
            type: String,
            default: 'bottom'
        }
    },
    data() {
        return {
            bodyOpened: false,
            offsetY: '',
            offsetX: ''
        }
    },
    methods: {
        toggleBody($event) {
            setTimeout(() => {
                if (!this.eventTypeValid($event)) {
                    return
                }
                if (this.bodyOpened || this.disabled) {
                    this.bodyOpened = false
                    return
                }
                this.bodyOpened = !this.bodyOpened
                const overflowYClassNames = [
                    'popup-slot',
                    'feature-view-content',
                    'feature-view-side-content',
                    'list-content',
                    'pre-login-view'
                ]
                setTimeout(() => {
                    const selectorX =
                        this.$refs.selector.getBoundingClientRect().left
                    const body = document.getElementById('body').children[0]
                    const offsetHeight = body ? body.clientHeight : 0
                    const largestHeight = window.innerHeight - offsetHeight - 50
                    const path = this.$Utils.getElementPath($event)
                    const index = path.findIndex(item => {
                        return overflowYClassNames.includes(item.className)
                    })
                    let scrollOffset = 0
                    if (path[index]) {
                        scrollOffset = path[index].scrollTop
                    }
                    if (
                        (this.position == 'top' &&
                            largestHeight >= $event.clientY) ||
                        largestHeight < $event.clientY
                    ) {
                        const calculation = -scrollOffset - offsetHeight
                        const offset = this.position == 'top' ? 3 : 2.3
                        this.offsetY = `calc(${calculation}px - ${offset}rem)`
                    } else {
                        this.offsetY = `-${scrollOffset}px`
                    }
                    this.offsetX = `${window.innerWidth - selectorX}px`
                }, this.timeout)
            }, this.timeout / 2)
        },
        closeByHover() {
            if (this.type != 'hover') {
                return
            }
            this.bodyOpened = false
        },
        eventTypeValid($event) {
            if (!$event) {
                return
            }
            return (
                (this.type == 'click' && $event.type == 'click') ||
                (this.type == 'hover' && $event.type == 'mouseenter')
            )
        }
    }
}
</script>
<style lang="scss" scoped>
.overlay-body {
    position: fixed;
    z-index: $highest;
    max-height: 30vh;
    margin-left: -0.1rem;
    cursor: default;
}
.filter-click-area {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: $highest;
    cursor: default;
    &.-no-events {
        pointer-events: none;
    }
}
</style>
